/*
Based on Material Dashboard 2 React by Creative Tim (https://www.creative-tim.com)
Licensed under the MIT License (see LICENSE)

Original Copyright (c) 2013-2021 Creative Tim
Modifications (c) 2025 CodeWeave Solutions (Pty) Ltd
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Icons
import Icon from "@mui/material/Icon";

const FolderItem = ({ name, count, isActive, onClick, icon }) => (
  <MDBox
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    p={2}
    mb={1}
    borderRadius="lg"
    sx={{
      cursor: "pointer",
      backgroundColor: isActive ? "info.main" : "inherit",
      color: isActive ? "white" : "text.primary",
      "&:hover": {
        backgroundColor: isActive ? "info.dark" : "grey.100",
      },
      transition: "all 0.2s ease-in-out",
    }}
    onClick={onClick}
  >
    <MDBox display="flex" alignItems="center">
      <Icon sx={{ mr: 1, fontSize: "1.2rem" }}>
        {icon || (isActive ? "folder_open" : "folder")}
      </Icon>
      <MDTypography variant="button" fontWeight="medium">
        {name}
      </MDTypography>
    </MDBox>
    <MDBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="50%"
      sx={{
        backgroundColor: isActive ? "white" : "grey.300",
        color: isActive ? "info.main" : "text.secondary",
        width: "24px",
        height: "24px",
        fontSize: "0.75rem",
        fontWeight: "bold",
      }}
    >
      {count}
    </MDBox>
  </MDBox>
);

export default function templateFoldersData() {
  return {
    folders: [
      {
        id: "all",
        name: "All Templates",
        count: 11,
        isActive: true,
      },
      {
        id: "investments",
        name: "Investments",
        count: 3,
        isActive: false,
      },
      {
        id: "medical-aid-gap",
        name: "Medical Aid and Gap",
        count: 2,
        isActive: false,
      },
      {
        id: "misc",
        name: "Misc",
        count: 1,
        isActive: false,
      },
      {
        id: "onboarding",
        name: "Onboarding",
        count: 3,
        isActive: false,
      },
      {
        id: "risk",
        name: "Risk",
        count: 2,
        isActive: false,
      },
      {
        id: "my-templates",
        name: "My Templates",
        count: 0,
        isActive: false,
        icon: "person",
      },
    ],
  };
} 